import React, {FunctionComponent} from "react";
import IconButton from "./IconButton";
import {faGithub} from "@fortawesome/free-brands-svg-icons";

export const GithubButton: FunctionComponent<{resource: any}> = ({resource}) => {
	return resource && resource.social.github
			? resource._object === 'Organization'
				? <a href={`https://github.com/${resource.social.github}`} target='_blank' rel="noreferrer">
					<IconButton
						size={'xs'}
						iconSize={'lg'}
						fillColor={'cyan'}
						icon={faGithub as any}
					/>
				</a>
				: <a href={`https://github.com/${resource.social.github.username}`} target='_blank' rel="noreferrer">
					<IconButton
						size={'xs'}
						iconSize={'lg'}
						fillColor={'cyan'}
						icon={faGithub as any}
					/>
				</a> : null;
}

export default GithubButton;
